import { expenseActionTypes } from '@Actions/purchase/expense/expenseActions';

const ExpenseReducers = (state = { }, action) => {
  switch (action.type) {
  case expenseActionTypes.GET_EXPENSE.LOADING: {
    const { getExpenseLoading } = action;
    return {
      ...state,
      getExpenseLoading,
    };
  }
  case expenseActionTypes.GET_EXPENSE.SUCCESS: {
    const { expense } = action;
    return {
      ...state,
      expense,
    };
  }

  case expenseActionTypes.CREATE_EXPENSE.LOADING: {
    const { createExpenseLoading } = action;
    return {
      ...state,
      createExpenseLoading,
    };
  }
  case expenseActionTypes.UPDATE_EXPENSE.LOADING: {
    const { updateExpenseLoading } = action;
    return {
      ...state,
      updateExpenseLoading,
    };
  }

  case expenseActionTypes.DELETE_EXPENSE.LOADING: {
    const { deleteExpenseLoading } = action;
    return {
      ...state,
      deleteExpenseLoading,
    };
  }

  case expenseActionTypes.LINK_EXPENSE.LOADING: {
    const { linkExpenseLoading } = action;
    return {
      ...state,
      linkExpenseLoading,
    };
  }
  case expenseActionTypes.UNLINK_EXPENSE.LOADING: {
    const { unLinkExpenseLoading } = action;
    return {
      ...state,
      unLinkExpenseLoading,
    };
  }
  // case expenseActionTypes.UPDATE_PAYMENT_OUTGOING_WORKFLOW.LOADING: {
  //   const { updatePaymentOutgoingWorkflowLoading } = action;
  //   return {
  //     ...state,
  //     updatePaymentOutgoingWorkflowLoading,
  //   };
  // }
  case expenseActionTypes.GET_EXPENSE_BY_ID.LOADING: {
    const { getExpenseByIdLoading } = action;
    return {
      ...state,
      getExpenseByIdLoading,
    };
  }
  case expenseActionTypes.GET_EXPENSE_BY_ID.SUCCESS: {
    const { expenseById } = action;
    return {
      ...state,
      expenseById,
    };
  }

  case expenseActionTypes.GET_ACCOUNT.LOADING: {
    const { getAccountLoading } = action;
    return {
      ...state,
      getAccountLoading,
    };
  }
  case expenseActionTypes.GET_ACCOUNT.SUCCESS: {
    const { accounts } = action;
    return {
      ...state,
      accounts,
    };
  }

  case expenseActionTypes.CREATE_ACCOUNT.LOADING: {
    const { createAccountLoading } = action;
    return {
      ...state,
      createAccountLoading,
    };
  }
  case expenseActionTypes.UPDATE_ACCOUNT.LOADING: {
    const { updateAccountLoading } = action;
    return {
      ...state,
      updateAccountLoading,
    };
  }

  case expenseActionTypes.DELETE_ACCOUNT.LOADING: {
    const { deleteAccountLoading } = action;
    return {
      ...state,
      deleteAccountLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default ExpenseReducers;
